import type { RouterContextType } from "@/api/permissions/permissions.api";
import { authGuardWithPermissions } from "@/utils/authGuard";
import { createFileRoute, useParams } from "@tanstack/react-router";
import { UserFormPage } from "./index";

export const Route = createFileRoute("/user-management/add-user/$userId")({
  component: EditUserPage,
  beforeLoad: async (args) => {
    await authGuardWithPermissions({
      context: args.context as RouterContextType,
      location: args.location as { pathname: string },
    });
  },
});

function EditUserPage() {
  const { userId } = useParams({ from: "/user-management/add-user/$userId" });
  return <UserFormPage userId={userId} />;
}
